/* ==========================================================================
   Umbro South Africa - theme behaviours
   Ported from the prototype assets/js/site.js. Same blocks, same guards:
   each one checks its markup is on the page before it runs.
   What changed for Shopify:
   - The cart talks to the AJAX API (/cart.js, /cart/add.js, /cart/change.js)
     instead of localStorage. The drawer arrives server-rendered and this
     script repaints it after every change.
   - The listing page sorts, filters and paginates through real URLs and the
     Section Rendering API instead of a client-side catalogue.
   - Search, newsletter and contact forms are real, so the prototype's demo
     toasts are gone.
   ========================================================================== */

(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* Words the script writes. They come from the theme's words file through a
     JSON block in the bag panel, so the shop owner edits them under Edit
     default theme content. The English here is only the fallback. */
  var STR = { empty: "Your bag is empty.", size: "Size __SIZE__", qty: "Qty __QTY__", remove: "Remove",
    add_error: "Could not add to bag", open_menu: "Open menu", close_menu: "Close menu",
    show_sections: "Show __NAME__ sections" };
  try {
    var strEl = document.querySelector("[data-umbro-strings]");
    if (strEl) {
      var given = JSON.parse(strEl.textContent);
      Object.keys(given).forEach(function (k) { if (given[k]) STR[k] = given[k]; });
    }
  } catch (err) { /* keep the fallback words */ }
  var esc = function (t) {
    return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  };

  var money = function (cents) {
    return "R " + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  /* ------------------------------------------------------------ 1. overlays */

  var scrim = $("[data-scrim]");
  var burger = $(".header__burger");
  var headerBar = $(".header");

  /* The menu panel hangs off the bottom edge of the header. That edge is not a
     constant: the announcement bar sits above the header and scrolls away, and
     it can be dismissed outright. Measure it at the moment the panel opens and
     hand it to the stylesheet. */
  function syncMenuTop() {
    if (!headerBar) return;
    var bottom = Math.max(0, Math.round(headerBar.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty("--menu-top", bottom + "px");
  }

  function setBurger(isOpen) {
    if (!burger) return;
    burger.classList.toggle("is-open", isOpen);
    burger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    burger.setAttribute("aria-label", isOpen ? STR.close_menu : STR.open_menu);
    document.body.classList.toggle("has-menu", isOpen);
  }

  function closeAll() {
    $$("[data-overlay]").forEach(function (el) { el.classList.remove("is-open"); });
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
    setBurger(false);
  }

  function open(el) {
    if (!el) return;
    closeAll();
    if (el.classList.contains("mobile-nav")) {
      syncMenuTop();
      setBurger(true);
    }
    el.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var field = el.querySelector("input[type=search], input[type=text], [data-autofocus]");
    if (field) setTimeout(function () { field.focus(); }, 260);
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-open]");
    if (opener) {
      e.preventDefault();
      var panel = $("[data-overlay='" + opener.getAttribute("data-open") + "']");
      /* The burger is now the close control as well, so a second press on an
         open panel has to shut it rather than reopen it. */
      if (panel && panel.classList.contains("is-open")) closeAll();
      else open(panel);
      return;
    }
    if (e.target.closest("[data-close]") || e.target === scrim) closeAll();
  });

  window.addEventListener("resize", function () {
    if (document.body.classList.contains("has-menu")) syncMenuTop();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll();
  });

  /* --------------------------------------------- 1b. mobile menu sections */

  /* The toggles are built here rather than written into the markup, so one
     change covers every template. Without script the sub-lists stay open. */
  (function () {
    var nav = $(".mobile-nav__list");
    if (!nav) return;
    var groups = $$(":scope > li", nav).filter(function (li) {
      return li.querySelector("ul");
    });
    groups.forEach(function (li, i) {
      var link = li.querySelector("a");
      var sub = li.querySelector("ul");
      if (!link || !sub) return;

      var id = "mnav-sub-" + i;
      sub.id = id;

      var row = document.createElement("div");
      row.className = "mobile-nav__row";
      link.parentNode.insertBefore(row, link);
      row.appendChild(link);

      var wrap = document.createElement("div");
      wrap.className = "mobile-nav__wrap";
      li.appendChild(wrap);
      wrap.appendChild(sub);

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mobile-nav__toggle";
      btn.setAttribute("aria-controls", id);
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-label", STR.show_sections.replace("__NAME__", link.textContent.trim()));
      btn.innerHTML = '<span class="mobile-nav__pm" aria-hidden="true"></span>';
      row.appendChild(btn);

      li.classList.add("has-sub");
      btn.addEventListener("click", function () {
        var open = li.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  })();

  /* ---------------------------------------------------------- 1c. header fit */

  /* The menu tabs are set in the theme editor, so the stylesheet can only size
     the type for the nine tabs the shop ships with. If the row of words runs
     into the wordmark or off the left edge, the header takes the burger, the
     same header a tablet gets. Every check lifts the fallback first, so a menu
     that is made shorter again gets its words back. It waits for the web font:
     the fallback font is wider and would trip it on every first visit. */
  function fitHeader() {
    var head = $(".header");
    if (!head) return;
    head.classList.remove("header--compact");
    var nav = $(".nav", head);
    var mark = $(".header__logo", head);
    if (!nav || !mark || getComputedStyle(nav).display === "none") return;
    var links = $$(".nav__link", nav);
    if (!links.length) return;
    var first = links[0].getBoundingClientRect();
    var last = links[links.length - 1].getBoundingClientRect();
    if (first.left < 0 || last.right + 16 > mark.getBoundingClientRect().left) {
      head.classList.add("header--compact");
    }
  }

  var fitQueued = false;
  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    requestAnimationFrame(function () {
      fitQueued = false;
      fitHeader();
    });
  }

  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () {
    fitHeader();
    window.addEventListener("resize", queueFit);
    document.addEventListener("shopify:section:load", queueFit);
  });

  /* ------------------------------------------------------ 2. announcement */

  var announce = $("[data-announce]");
  if (announce) {
    var lines = $$("p", announce);
    if (lines.length > 1) {
      var at = 0;
      lines.forEach(function (p, i) { p.hidden = i !== 0; });
      setInterval(function () {
        lines[at].hidden = true;
        at = (at + 1) % lines.length;
        lines[at].hidden = false;
      }, 5000);
    }
    var dismiss = $("[data-announce-close]", announce);
    if (dismiss) dismiss.addEventListener("click", function () { announce.hidden = true; });
  }

  /* ------------------------------------------------------------- 3. hero */

  function initHero(hero) {
    if (!hero || hero._umbroHero) return;
    var slides = $$("[data-hero-slide]", hero);
    if (!slides.length) return;
    var counter = $("[data-hero-count]", hero);
    var current = 0;
    var timer = null;
    var autoplay = hero.getAttribute("data-hero-autoplay") !== "false";
    var interval = parseInt(hero.getAttribute("data-hero-interval"), 10) || 6500;
    var pauseHover = hero.getAttribute("data-hero-pause-hover") !== "false";

    var show = function (i) {
      if (typeof i === "number") {
        current = (i + slides.length) % slides.length;
      } else if (i && i.nodeType) {
        var idx = slides.indexOf(i);
        if (idx < 0) return;
        current = idx;
      }
      slides.forEach(function (s, n) { s.classList.toggle("is-active", n === current); });
      if (counter) counter.textContent = ("0" + (current + 1)).slice(-2) + " / " + ("0" + slides.length).slice(-2);
    };

    var stop = function () { clearInterval(timer); timer = null; };

    var play = function () {
      stop();
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    };

    $$("[data-hero-prev]", hero).forEach(function (b) {
      b.addEventListener("click", function () { show(current - 1); play(); });
    });
    $$("[data-hero-next]", hero).forEach(function (b) {
      b.addEventListener("click", function () { show(current + 1); play(); });
    });

    if (pauseHover) {
      hero.addEventListener("mouseenter", stop);
      hero.addEventListener("mouseleave", play);
    }

    show(0);
    play();

    hero._umbroHero = { show: show, play: play, stop: stop };
  }

  $$("[data-hero]").forEach(initHero);

  document.addEventListener("shopify:section:load", function (event) {
    $$("[data-hero]", event.target).forEach(function (el) {
      el._umbroHero = null;
      initHero(el);
    });
  });

  document.addEventListener("shopify:block:select", function (event) {
    var slide = event.target.closest("[data-hero-slide]");
    if (!slide) return;
    var hero = slide.closest("[data-hero]");
    if (!hero) return;
    if (!hero._umbroHero) initHero(hero);
    if (!hero._umbroHero) return;
    hero._umbroHero.show(slide);
    hero._umbroHero.stop();
  });

  document.addEventListener("shopify:block:deselect", function (event) {
    var slide = event.target.closest("[data-hero-slide]");
    if (!slide) return;
    var hero = slide.closest("[data-hero]");
    if (hero && hero._umbroHero) hero._umbroHero.play();
  });

  /* ------------------------------------------------------------- 4. rails */

  /* A target can be a single rail or a group of pill-switched rails. In a
     group, drive whichever rail is currently visible. */
  function railFor(id) {
    var target = document.getElementById(id);
    if (!target) return null;
    if (target.classList.contains("rail")) return target;
    return $(".rail:not([hidden])", target) || $(".rail", target);
  }

  $$("[data-rail-prev], [data-rail-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var rail = railFor(btn.getAttribute("data-rail-target"));
      if (!rail) return;
      var step = rail.firstElementChild ? rail.firstElementChild.offsetWidth + 20 : 300;
      var by = Math.max(step, Math.round(rail.clientWidth * 0.8 / step) * step);
      rail.scrollBy({ left: btn.hasAttribute("data-rail-prev") ? -by : by, behavior: "smooth" });
    });
  });

  /* Pill filters over a rail. The rails arrive server-rendered, one per
     collection, and the pills switch which one shows. */
  $$("[data-pills]").forEach(function (row) {
    var group = document.getElementById(row.getAttribute("data-pills"));
    if (!group) return;
    row.addEventListener("click", function (e) {
      var pill = e.target.closest(".pill");
      if (!pill || pill.getAttribute("aria-selected") === "true") return;
      $$(".pill", row).forEach(function (b) { b.setAttribute("aria-selected", "false"); });
      pill.setAttribute("aria-selected", "true");
      $$(".rail", group).forEach(function (rail) {
        rail.hidden = rail.getAttribute("data-rail-pane") !== pill.getAttribute("data-rail-pane");
        if (!rail.hidden) rail.scrollLeft = 0;
      });
    });
  });

  /* ----------------------------------------------------- 5. detail toggles */

  $$("[data-accordion]").forEach(function (group) {
    group.addEventListener("toggle", function () {
      if (!group.open) return;
      $$("[data-accordion]", group.parentNode).forEach(function (other) {
        if (other !== group && other.hasAttribute("data-exclusive")) other.open = false;
      });
    });
  });

  var filterToggle = $("[data-filter-toggle]");
  if (filterToggle) {
    filterToggle.addEventListener("click", function () {
      $("[data-filters]").classList.toggle("is-open");
    });
  }

  /* -------------------------------------------------------------- 6. cart */

  /* The drawer body arrives server-rendered. This block repaints it from
     /cart.js after every change, using the same line-item markup. */

  function paintCart(cart) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    var body = $("[data-cart-body]");
    if (!body) return;
    var promise = $(".drawer [data-cart-promise]");
    if (promise) promise.hidden = !cart.items.length;

    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer__empty">' + esc(STR.empty) + '</p>';
      $("[data-cart-foot]").hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item, n) {
      var img = item.image
        ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, "_152x$1$2")
        : "";
      var meta = [];
      if (item.variant_title && item.variant_title !== "Default Title") {
        meta.push(STR.size.replace("__SIZE__", item.variant_title));
      }
      meta.push(STR.qty.replace("__QTY__", item.quantity));
      return '<div class="line-item">' +
        '<img src="' + img + '" alt="" width="76" height="76" loading="lazy">' +
        '<div>' +
          '<p class="line-item__name">' + item.product_title + '</p>' +
          '<p class="line-item__meta">' + esc(meta.join(" / ")) + '</p>' +
          '<button class="line-item__remove" data-cart-remove="' + (n + 1) + '">' + esc(STR.remove) + '</button>' +
        '</div>' +
        '<div>' + money(item.final_line_price) + '</div>' +
      '</div>';
    }).join("");

    $("[data-cart-total]").textContent = money(cart.total_price);
    $("[data-cart-foot]").hidden = false;
  }

  /* --------------------------------------------------- 6b. delivery dates */

  /* The bag shows expected delivery in South Africa as dates. The theme
     settings hold the range in working days (shipping policy: 1-2 days
     processing plus 5-7 working days shipping). Weekends and South African
     public holidays do not count, as the policy says. Without script the
     range stays in working days. */

  var DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var holidayCache = {};

  function saHolidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    /* Easter Sunday by the anonymous Gregorian algorithm. Good Friday and
       Family Day hang off it. */
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    var fixed = [[0, 1], [2, 21], [3, 27], [4, 1], [5, 16], [7, 9], [8, 24], [11, 16], [11, 25], [11, 26]]
      .map(function (md) { return new Date(year, md[0], md[1]); });
    /* A holiday that falls on a Sunday moves to the Monday. */
    var moved = fixed.filter(function (dt) { return dt.getDay() === 0; })
      .map(function (dt) { return new Date(year, dt.getMonth(), dt.getDate() + 1); });
    var list = fixed.concat(moved, [new Date(year, month, day - 2), new Date(year, month, day + 1)]);
    holidayCache[year] = list.map(function (dt) { return dt.toDateString(); });
    return holidayCache[year];
  }

  function addWorkingDays(from, n) {
    var dt = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      dt.setDate(dt.getDate() + 1);
      var off = dt.getDay() === 0 || dt.getDay() === 6 ||
        saHolidays(dt.getFullYear()).indexOf(dt.toDateString()) !== -1;
      if (!off) n--;
    }
    return dt;
  }

  function shortDate(dt) {
    return DAYS[dt.getDay()] + " " + dt.getDate() + " " + MONTHS[dt.getMonth()];
  }

  $$("[data-eta]").forEach(function (el) {
    var lo = parseInt(el.getAttribute("data-eta-min"), 10);
    var hi = parseInt(el.getAttribute("data-eta-max"), 10);
    if (!(lo > 0) || !(hi >= lo)) return;
    var today = new Date();
    el.textContent = shortDate(addWorkingDays(today, lo)) + " – " + shortDate(addWorkingDays(today, hi));
  });

  function refreshCart(thenOpen) {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCart(cart);
        if (thenOpen) open($("[data-overlay='cart']"));
      });
  }

  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-cart-remove]");
    if (!rm) return;
    rm.disabled = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: parseInt(rm.getAttribute("data-cart-remove"), 10), quantity: 0 })
    }).then(function () { refreshCart(false); });
  });

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return refreshCart(true);
    });
  }

  /* ------------------------------------------- 6c. product grid quick view */

  /* Each grid card carries a small JSON block. Quick view paints the shared
     panel in that section from it, then opens the panel with the overlay code
     above. Add to bag is the same call the product page makes, so the bag
     opens on success exactly as it does there. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qv-open]");
    if (!btn) return;
    var card = btn.closest(".gcard");
    var panel = btn.closest(".na") && $("[data-qv]", btn.closest(".na"));
    var raw = card && $("[data-qv-data]", card);
    if (!panel || !raw) return;
    e.preventDefault();
    var data;
    try { data = JSON.parse(raw.textContent); } catch (err) { return; }

    var img = $("[data-qv-img]", panel);
    img.src = data.image || "";
    img.alt = data.alt || data.title;
    $("[data-qv-title]", panel).textContent = data.title;
    $("[data-qv-link]", panel).href = data.url;
    var msg = $("[data-qv-msg]", panel);
    msg.hidden = true;

    var priceBox = $("[data-qv-price]", panel);
    var stitchBox = $("[data-qv-stitch]", panel);
    var paintPrice = function (v) {
      priceBox.innerHTML = v.compare > v.price
        ? "<del>" + money(v.compare) + "</del><ins>" + money(v.price) + "</ins>"
        : money(v.price);
      if (stitchBox) showStitch(stitchBox, v.price / 100);
    };
    var chosen = null;
    var addBtn = $("[data-qv-add]", panel);
    var soldOut = panel.getAttribute("data-qv-sold-out") || "Sold out";
    if (!addBtn.hasAttribute("data-label")) addBtn.setAttribute("data-label", addBtn.textContent);
    var addLabel = addBtn.getAttribute("data-label");

    var variants = data.variants || [];
    var single = variants.length === 1 && variants[0].title === "Default Title";
    var list = $("[data-qv-sizes]", panel);
    $("[data-qv-sizes-wrap]", panel).hidden = single;
    list.innerHTML = "";
    if (variants.length === 1) {
      /* One option only, for example a ball in size 5: it is already the
         choice, so the shopper should not have to click it. */
      chosen = variants[0];
    }
    if (!single) {
      variants.forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = v.title;
        b.disabled = !v.available;
        b.setAttribute("data-variant-id", v.id);
        if (chosen === v) b.classList.add("is-active");
        b.addEventListener("click", function () {
          $$("button", list).forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
          chosen = v;
          paintPrice(v);
          addBtn.disabled = false;
          msg.hidden = true;
        });
        list.appendChild(b);
      });
    }
    var anyAvailable = variants.some(function (v) { return v.available; });
    paintPrice(chosen || variants[0] || { price: 0, compare: 0 });
    addBtn.textContent = anyAvailable ? addLabel : soldOut;
    addBtn.disabled = !anyAvailable || !chosen;

    addBtn.onclick = function () {
      if (!chosen) return;
      addBtn.disabled = true;
      addToCart(chosen.id, 1)
        .catch(function (err) {
          msg.textContent = (err && err.description) || panel.getAttribute("data-qv-error");
          msg.hidden = false;
          addBtn.disabled = false;
        });
    };

    open(panel);
  });

  /* ------------------------------------------------ 6d. Stitch Pay Later */

  /* The product page loads Stitch's script in its own markup, as the live
     store does. Quick view loads it on the first open instead, so the home
     page does not wait for it. Each quick view panel gets its own Stitch
     widget on its own box; the live store reuses one box id in every quick
     shop, so there the card only ever reaches the first one. If Stitch cannot
     load, the box stays empty and nothing else changes. */
  var STITCH_SRC = "https://express.stitch.money/js/bnpl-widget.v1.js";
  var stitchLoading = null;

  function loadStitch() {
    if (window.StitchBNPL) return Promise.resolve(window.StitchBNPL);
    if (!stitchLoading) {
      stitchLoading = new Promise(function (resolve, reject) {
        var s = document.createElement("script");
        s.src = STITCH_SRC;
        s.async = true;
        s.onload = function () { resolve(window.StitchBNPL); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return stitchLoading;
  }

  function showStitch(box, price) {
    loadStitch().then(function (api) {
      if (!api) return;
      if (box._stitch) {
        /* Same price, same card: a redraw would only replay Stitch's fade. */
        if (box._stitchPrice !== price) box._stitch.setPrice(price);
        box._stitchPrice = price;
        return;
      }
      box._stitchPrice = price;
      box._stitch = api.createWidget({
        mountSelector: "#" + box.id,
        price: price,
        minimumAmount: parseFloat(box.getAttribute("data-min")) || 100,
        logoBg: box.getAttribute("data-logo") || "purple",
        width: "100%",
        locale: "en-ZA",
        currency: "ZAR"
      });
    }).catch(function () { /* no card without Stitch */ });
  }

  /* ------------------------------------------------------- 7. listing page */

  /* Sorting and filtering are real URLs now, so the browser does the work.
     Only "Load more" stays client-side, through the Section Rendering API. */

  var sortSelect = $("[data-sort]");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      var url = new URL(location.href);
      if (sortSelect.value) url.searchParams.set("sort_by", sortSelect.value);
      else url.searchParams.delete("sort_by");
      url.searchParams.delete("page");
      location.assign(url.href);
    });
  }

  var filterForm = $("[data-filter-form]");
  if (filterForm) {
    filterForm.addEventListener("change", function () {
      filterForm.submit();
    });
  }

  var moreBtn = $("[data-more]");
  if (moreBtn) {
    moreBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var next = moreBtn.getAttribute("data-next-url");
      var sectionId = moreBtn.getAttribute("data-section-id");
      if (!next || moreBtn.hasAttribute("data-busy")) return;
      moreBtn.setAttribute("data-busy", "");
      var url = new URL(next, location.origin);
      url.searchParams.set("section_id", sectionId);
      fetch(url.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var grid = $("[data-grid]");
          var incoming = doc.querySelector("[data-grid]");
          if (grid && incoming) {
            while (incoming.firstChild) grid.appendChild(incoming.firstChild);
          }
          var incomingBtn = doc.querySelector("[data-more]");
          var nextUrl = incomingBtn && incomingBtn.getAttribute("data-next-url");
          if (nextUrl) {
            moreBtn.setAttribute("data-next-url", nextUrl);
            moreBtn.setAttribute("href", nextUrl);
            moreBtn.removeAttribute("data-busy");
          } else {
            moreBtn.hidden = true;
          }
        });
    });
  }

  /* ------------------------------------------------------- 8. detail page */

  var pdp = $("[data-pdp]");
  if (pdp) {
    var main = $("[data-pdp-main]");

    /* "Only X left in stock". Liquid writes data-low on a size only when that
       size is tracked, cannot oversell, and is at or under the threshold, so
       the page never carries a stock count above it. */
    var stock = $("[data-pdp-stock]");
    var showStock = function (n) {
      if (!stock) return;
      stock.hidden = !n;
      if (n) $("[data-pdp-stock-n]", stock).textContent = n;
    };
    /* The price box and the Stitch Pay Later card follow the chosen variant.
       Size buttons and select options both carry data-price in cents. Stitch
       redraws and fades its card in on every price it is given, so it only
       hears about a price that changed: most sizes cost the same. */
    var stitchPrice = null;
    var showPrice = function (el) {
      if (!el || !el.hasAttribute("data-price")) return;
      var now = parseInt(el.getAttribute("data-price"), 10);
      var was = parseInt(el.getAttribute("data-compare") || "0", 10);
      var priceBox = $("[data-pdp-price]");
      if (priceBox) {
        priceBox.innerHTML = was > now
          ? "<del>" + money(was) + "</del><ins>" + money(now) + "</ins>"
          : money(now);
      }
      var stitchBox = $("#stitch-bnpl-widget");
      if (stitchPrice === null && stitchBox) stitchPrice = parseInt(stitchBox.getAttribute("data-price"), 10);
      if (window.StitchBNPL && stitchBox && now !== stitchPrice) {
        stitchPrice = now;
        window.StitchBNPL.setPrice(now / 100);
      }
    };

    var variantSelect = $("select[data-pdp-variant]");
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        showStock(opt && opt.getAttribute("data-low"));
        showPrice(opt);
      });
    }

    pdp.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-shot]");
      if (thumb) {
        main.src = thumb.getAttribute("data-shot");
        main.srcset = thumb.getAttribute("data-shot-srcset") || "";
        $$("[data-pdp-thumbs] button").forEach(function (b) { b.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        return;
      }
      var size = e.target.closest("[data-pdp-sizes] button");
      if (size && !size.disabled) {
        $$("[data-pdp-sizes] button").forEach(function (b) { b.classList.remove("is-active"); });
        size.classList.add("is-active");
        showStock(size.getAttribute("data-low"));
        showPrice(size);
      }
    });

    var qtyInput = $("[data-qty]");
    $$("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var next = parseInt(qtyInput.value, 10) + parseInt(b.getAttribute("data-qty-step"), 10);
        qtyInput.value = Math.max(1, Math.min(10, isNaN(next) ? 1 : next));
      });
    });

    var addBtn = $("[data-add]");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var chosen = $("[data-pdp-sizes] button.is-active") || $("[data-pdp-variant]");
        if (!chosen) return;
        var variantId = parseInt(chosen.getAttribute("data-variant-id") || chosen.value, 10);
        if (!variantId) return;
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addToCart(variantId, parseInt(qtyInput.value, 10) || 1)
          .catch(function (err) {
            addBtn.textContent = (err && err.description) || STR.add_error;
            setTimeout(function () { addBtn.textContent = label; }, 3000);
          })
          .then(function () { addBtn.disabled = false; });
      });
    }
  }

  /* ------------------------------------------------------ 8b. size guide */

  /* Products without Cole's chart link to the size guide page. The shared
     overlay code above opens the pop-up; this fetches the page once and moves
     its chart and text in, so the page stays the one place to edit. The fetch
     starts on hover or touch, so the pop-up is usually full when it opens.
     If it fails, the link does what it did before and opens the page. */
  var guideLink = $("[data-size-guide]");
  var guideBody = $("[data-size-guide-body]");
  if (guideLink && guideBody) {
    var guideLoad = null;
    var loadGuide = function () {
      if (!guideLoad) {
        guideLoad = fetch(guideLink.href, { credentials: "same-origin" })
          .then(function (r) {
            if (!r.ok) throw new Error("size guide " + r.status);
            return r.text();
          })
          .then(function (html) {
            var article = new DOMParser().parseFromString(html, "text/html").querySelector(".content-layout");
            if (!article) throw new Error("size guide page has no content");
            $$(".eyebrow, .content-title", article).forEach(function (el) { el.parentNode.removeChild(el); });
            return article;
          });
        guideLoad.catch(function () { guideLoad = null; });
      }
      return guideLoad;
    };
    ["pointerenter", "touchstart", "focus"].forEach(function (type) {
      guideLink.addEventListener(type, function () { loadGuide().catch(function () {}); }, { once: true, passive: true });
    });
    guideLink.addEventListener("click", function () {
      loadGuide()
        .then(function (article) {
          if (guideBody.hasAttribute("data-loaded")) return;
          guideBody.innerHTML = "";
          while (article.firstChild) guideBody.appendChild(article.firstChild);
          guideBody.setAttribute("data-loaded", "");
        })
        .catch(function () { window.location.href = guideLink.href; });
    });
  }

  /* --------------------------------------------------------- 9. articles */

  /* Body images arrive inside the article HTML, below the fold. */
  var articleBody = $("[data-article-body]");
  if (articleBody) {
    $$("img", articleBody).forEach(function (img) {
      img.loading = "lazy";
      img.decoding = "async";
    });
  }
})();
